'use client';

import type { FunctionComponent } from 'react';

export type LiveStatusTone = 'thinking' | 'working' | 'waiting';

export interface LiveStatus {
  tone: LiveStatusTone;
  label: string;
}

const LIVE_STATUS_CLASSES: Record<LiveStatusTone, { wrap: string; dot: string }> = {
  thinking: { wrap: 'border-acc-soft bg-acc-soft-2 text-acc', dot: 'bg-acc' },
  working: { wrap: 'border-sky-soft bg-sky-soft text-sky', dot: 'bg-sky' },
  waiting: { wrap: 'border-amber-soft bg-amber-soft text-amber', dot: 'bg-amber' },
};

export const ChatLiveStatus: FunctionComponent<{ status: LiveStatus }> = ({ status }) => {
  const classes = LIVE_STATUS_CLASSES[status.tone];
  return (
    <div
      className={`inline-flex max-w-full items-center gap-1.5 rounded-[6px] border px-2 py-1 text-[11.5px] leading-[1.35] font-sans ${classes.wrap}`}
      role="status"
      aria-live="polite"
    >
      <span className={`h-1.5 w-1.5 flex-shrink-0 animate-pulse rounded-full ${classes.dot}`} />
      <span className="min-w-0">{status.label}</span>
    </div>
  );
};
